import React from 'react';
import {useTranslation} from 'react-i18next';
import {Platform, Text, TouchableOpacity} from 'react-native';
import LinearGradient from '../../imports/lineargradient';
import styles from './FallbackError.style';
import RNRestart from '../../imports/RNRestart';

function FallbackError() {
  const {t} = useTranslation();

  return (
    <LinearGradient
      colors={['#B82025', '#F34F42']}
      style={styles.container}
      useAngle={true}
      angle={180}>
      <Text style={styles.text}>
        {t('processing_error')}
        {'\n'}
        {t('run_program_again')}
      </Text>
      <TouchableOpacity
        style={styles.reloadButton}
        onPress={() => {
          if (Platform.OS === 'web') {
            window.location.reload(true);
          } else {
            RNRestart.Restart();
          }
        }}>
        <Text style={styles.reloadText}>{t('reload_app')}</Text>
      </TouchableOpacity>
    </LinearGradient>
  );
}

export default FallbackError;
